import React, { useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import { FormattedMessage } from 'react-intl';
import PropdocsModal from '../../../modal/PropdocsModal';
import AddNewTeamFormik from '../../../../forms/AddNewTeamFormContainer';
import { TitleFormattedMessage } from '../../../titleFormattedMessage';

interface Props {
  handleHide: () => void;
  show: boolean;
}

const CreateNewTeamModal = ({ handleHide, show }: Props) => {
  // Focus the workspace name input when modal opens
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        const input = document.getElementById('addNewTeamForm.teamName') as HTMLInputElement;
        if (input) input.focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [show]);

  // Create containers for the form
  const BodyContainer = ({ children }: { children: React.ReactNode }) => <div>{children}</div>;

  const ActionsContainer = ({ children }: { children: React.ReactNode }) => (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '1rem' }}>{children}</div>
  );

  return (
    <PropdocsModal
      show={show}
      setShow={handleHide}
      size="md"
      title={<FormattedMessage id="title.add-team-member" defaultMessage="Create a Workspace" />}
    >
      <AddNewTeamFormik
        // @ts-ignore
        bodyContainer={BodyContainer}
        // @ts-ignore
        actionsContainer={ActionsContainer}
        renderSecondaryAction={() => (
          <Button variant="link" className="text-secondary" onClick={handleHide}>
            <TitleFormattedMessage id="cta.cancel" defaultMessage="Cancel" />
          </Button>
        )}
        onSuccess={handleHide}
      />
    </PropdocsModal>
  );
};

export default CreateNewTeamModal;
